import { SourceAttribution } from "src/components/pages/home/store/types";

export const processCitations = (
  text: string,
  sourceAttributions: SourceAttribution[],
): string => {
  if (!sourceAttributions || sourceAttributions.length === 0) {
    return text;
  }

  // Sort all segments by beginOffset in reverse order to avoid offset shifts
  const allSegments: Array<{
    beginOffset: number;
    endOffset: number;
    citationNumber: number;
  }> = [];

  for (const attr of sourceAttributions) {
    for (const segment of attr.textMessageSegments || []) {
      allSegments.push({
        beginOffset: segment.beginOffset,
        endOffset: segment.endOffset,
        citationNumber: attr.citationNumber,
      });
    }
  }

  allSegments.sort((a, b) => b.beginOffset - a.beginOffset);

  // Insert citation markers
  let result = text;
  for (const { endOffset, citationNumber } of allSegments) {
    result =
      result.slice(0, endOffset) +
      `[${citationNumber}]` +
      result.slice(endOffset);
  }

  return result;
};
